import {
	GET_VEHICLE,
	SAVE_VEHICLE,
	GET_VEHICLE_EVENTS
} from './vehicle-mutation-types';
import api from '@/services/api-service';
import buildRoute from '@/composables/build-route';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'vehicle',
	namespaced: true,
	state: {
		vehicleResult: {}
	},
	mutations: {
		[GET_VEHICLE](state, vehicle) {
			state.vehicleResult = vehicle;
		},
		[SAVE_VEHICLE](state, vehicle) {
			state.vehicleResult = vehicle;
		},
		[GET_VEHICLE_EVENTS](state, vehicleEvents) {
			state.vehicleEvents = vehicleEvents;
		}
	},
	actions: {
		// actions let us get to ({ state, getters, commit, dispatch }) {
		async getVehicleAction({ commit }, id) {
			const route = buildRoute('/vehicle/{id}', { id: id });
			const vehicle = await api.get(route);
			commit(GET_VEHICLE, vehicle);
			return vehicle;
		},
		async createVehicleAction({ commit }, vehicle) {
			const newVehicle = await api.post('/vehicle', vehicle);
			commit(SAVE_VEHICLE, newVehicle);
			return newVehicle;
		},
		async updateVehicleAction({ commit }, vehicle) {
			const updatedVehicle = await api.put(
				buildRoute('/vehicle/{id}', { id: vehicle.id }),
				vehicle
			);
			commit(SAVE_VEHICLE, updatedVehicle);
			return updatedVehicle;
		},
		async getVehicleEventsAction({ commit }, id) {
			const vehicleEvents = await api.get(
				buildRoute('/vehicle/{id}/events', { id: id })
			);
			commit(GET_VEHICLE_EVENTS, vehicleEvents);
			return vehicleEvents;
		}
	},
	getters: {
		vehicleResult: state => state.vehicleResult,
		vehicleEvents: state => state.vehicleEvents
	}
};
